/* eslint-disable react/prop-types */

import React from 'react';
import images from '../../assets/images';
import Button from './Button';
import PropTypes from 'prop-types';

const BtnOpenEmailPhone = ({ dataType, text, openModalAlertPhone }) => {
    const sendEmailAndPhone = (e, type, emailPhone) => {
        const DATA = {
            Email: `mailto:${emailPhone}`,
            Phone: `tel:${emailPhone}`
        };
        e.preventDefault();
        window.location = DATA[type];
    };

    return (
        <Button
            fontSize="0.75rem"
            icon={text === 'Phone' ? images.phone : images.mail}
            alignImg="left"
            classs="btnMain"
            text={text}
            onClick={e =>
                openModalAlertPhone
                    ? openModalAlertPhone()
                    : sendEmailAndPhone(e, text, dataType)
            }
        />
    );
};
BtnOpenEmailPhone.propTypes = {
    dataType: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    openModalAlertPhone: PropTypes.fun
};

export default BtnOpenEmailPhone;
